export let props = ['title']
export let model = {
  dialog:false,
  user:{
    loginPwd:'',
  }
}
export let computed = {
  subTitle(){
    const route = this.$route.name;
    return this.$expressway.findTitleByRouteName(route);
  }
}
